import { Pipe, PipeTransform } from '@angular/core';
import { Specialite } from '../../models/specialite';

@Pipe({
	name: 'filterSpecialitesByName'
})
export class FilterSpecialitesByNamePipe implements PipeTransform {
	transform(specialite: Specialite[], filter: string): Specialite[] {
		if (
			!specialite ||
			!filter ||
			specialite === null ||
			filter === null ||
			filter === ''
		) {
			return specialite;
		}

		return specialite.filter((specialite: Specialite) => {
			if (specialite.name) {
				// TODO: add lastName too
				return specialite.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
